import BaseApi, { FetchMethodType } from 'api/BaseApi';

export interface IBorrowersInviteLink {
  url: string;
  isActive: boolean;
}

export interface IInviteBorrowerParams {
  email: string;
  intermediaryName: string;
}

export interface IBorrowersInviteApi {
  getInviteLink(): Promise<IBorrowersInviteLink>;
  invite(params: IInviteBorrowerParams): Promise<void>;
}

export class BorrowersInviteRestApi extends BaseApi implements IBorrowersInviteApi {
  public getInviteLink(): Promise<IBorrowersInviteLink> {
    return this.fetch('/borrowers-invite/link');
  }

  public invite(params: IInviteBorrowerParams): Promise<void> {
    return this.fetch('/borrowers-invite', {
      method: FetchMethodType.POST,
      body: {
        email: params.email,
        intermediaryName: params.intermediaryName,
      },
    });
  }
}
